import React from "react";
import { StickyContext } from "./StickyContainer";

type Props = {
    children({ }: {
        style: any;
    }): React.ReactElement;
}

type State = {
    style: { [x:string]: string | number };
};

export class Sticky extends React.Component<Props, State> {

    static contextType = StickyContext;

    private placeholder: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.placeholder = React.createRef();
        this.state = {
            style: {},
        };
    }

    componentDidMount() {
        this.context.subscribe(this.handleContainerEvent);
    }

    componentWillUnmount() {
        this.context.unsubscribe(this.handleContainerEvent);
    }

    handleContainerEvent = ({
        style,
    }) => {
        this.setState({
            style,
        });
    };

    render() {
        const element = React.cloneElement(
            this.props.children({
                style: this.state.style,
            })
        );

        return (
            <div>
                <div ref={this.placeholder} />
                {element}
            </div>
        );
    }
}
